// frontend/src/components/admin/modules/NetworkManager.js
import { api } from '../../../services/api.js';
import { Notification } from '../../../components/Notification.js';

async function openUserModal(userId = null, notificationContainer, onSave) {
    const isEditing = userId !== null;
    let userData = {};
    let allTracks = [];

    // Cargar pistas y datos de usuario en paralelo para mayor eficiencia
    const promises = [api.get('/tracks?admin_mode=true')];
    if (isEditing) {
        promises.push(api.get(`/users/${userId}`));
    }

    try {
        const [tracksResponse, userResponse] = await Promise.all(promises);
        allTracks = tracksResponse.tracks || tracksResponse;
        if (isEditing && userResponse) {
            userData = userResponse;
        }
    } catch (error) {
        Notification(notificationContainer, 'Error al cargar datos para el modal.', 'error');
        return;
    }

    const currency = userData.currency_code || 'USD';
    const autoUpdate = userData.auto_update_rate !== false; // Default to true if undefined
    const exchangeRate = userData.exchange_rate || '';
    const allowedTrackIds = new Set(userData.allowed_track_ids || []);
    // ⭐ NUEVO: Variable para capturar el estado del permiso de Win/Place
    const enableWinPlace = userData.enable_win_place !== false; 

    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'user-modal-overlay';
    modalOverlay.innerHTML = `
        <div class="user-modal-content">
            <h3>${isEditing ? 'Editar Usuario' : 'Crear Nuevo Usuario'}</h3>
            <form id="userForm" class="user-modal-form">
                <input type="hidden" id="userId" value="${userId || ''}">
                <div class="form-group">
                    <label for="username">Usuario</label>
                    <input type="text" id="username" value="${userData.username || ''}" required>
                </div>
                <div class="form-group">
                    <label for="fullName">Nombre Completo (Nombre de la Taquilla)</label>
                    <input type="text" id="fullName" value="${userData.full_name || ''}">
                </div>
                <div class="form-group">
                    <label for="allyName">Nombre del Aliado / Vendedor (Opcional)</label>
                    <input type="text" id="allyName" value="${userData.ally_name || ''}" placeholder="Ej: Vendedor Zona Norte">
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" id="email" value="${userData.email || ''}">
                </div>
                <div class="form-group">
                    <label for="phoneNumber">Número de Teléfono</label>
                    <input type="tel" id="phoneNumber" value="${userData.phone_number || ''}" placeholder="+584121234567">
                </div>
                <div class="form-group">
                    <label for="password">Contraseña ${isEditing ? '(Dejar en blanco para no cambiar)' : ''}</label>
                    <input type="password" id="password" ${isEditing ? '' : 'required'}>
                </div>
                <!-- ⭐ NUEVO: El Grid se expandió a 3 columnas para albergar el interruptor Win/Place -->
                <div class="form-grid" style="grid-template-columns: 1.5fr 1fr 1fr; align-items: end; gap: 15px;">
                    <div class="form-group" style="margin-bottom: 0;">
                        <label for="currencyCode">Moneda Base del Usuario</label>
                        <select id="currencyCode" required>
                            <option value="USD" ${currency === 'USD' ? 'selected' : ''}>Dólar Americano (USD)</option>
                            <option value="VES" ${currency === 'VES' ? 'selected' : ''}>Bolívar (VES)</option>
                            <option value="COP" ${currency === 'COP' ? 'selected' : ''}>Peso Colombiano (COP)</option>
                            <option value="BOTH" ${currency === 'BOTH' ? 'selected' : ''}>USD y VES (Ambos)</option>
                        </select>
                    </div>
                    <div class="form-group" style="margin-bottom: 0; padding-bottom: 10px;">
                        <label for="autoUpdateRate" style="flex-direction: row; align-items: center; gap: 10px; cursor: pointer;">
                            <input type="checkbox" id="autoUpdateRate" ${autoUpdate ? 'checked' : ''} style="width: 1.2em; height: 1.2em;">
                            <span>Tasa Auto</span>
                        </label>
                    </div>
                    <div class="form-group" style="margin-bottom: 0; padding-bottom: 10px;">
                        <label for="enableWinPlace" style="flex-direction: row; align-items: center; gap: 8px; cursor: pointer;">
                            <input type="checkbox" id="enableWinPlace" ${enableWinPlace ? 'checked' : ''} style="width: 1.2em; height: 1.2em; accent-color: #10b981;">
                            <span style="color: #10b981; font-weight: bold;">Win/Place</span>
                        </label>
                    </div>
                </div>
                <div class="form-group" id="exchangeRateGroup">
                    <label for="exchangeRate">Tasa de Cambio (a 1 USD)</label>
                    <input type="number" id="exchangeRate" value="${exchangeRate}" placeholder="Ej: 36.50" step="0.01" min="0" ${autoUpdate ? 'disabled' : ''}>
                </div>
                <div class="form-group">
                    <label for="role">Rol</label>
                    <select id="role" required>
                        <option value="cashier" ${userData.role === 'cashier' ? 'selected' : ''}>Cajero</option>
                        <option value="payout_agent" ${userData.role === 'payout_agent' ? 'selected' : ''}>Pagador</option>
                        <option value="admin" ${userData.role === 'admin' ? 'selected' : ''}>Admin</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Hipódromos Permitidos (Para Cajero)</label>
                    <div id="allowedTracksContainer" style="max-height: 150px; overflow-y: auto; background: #0f172a; padding: 10px; border-radius: 6px; border: 1px solid #475569;">
                        ${allTracks.map(track => `
                            <label style="display: flex; align-items: center; gap: 10px; cursor: pointer; padding: 5px;">
                                <input type="checkbox" class="allowed-track-checkbox" value="${track.id}" ${allowedTrackIds.has(track.id) ? 'checked' : ''} style="width: 1.2em; height: 1.2em;">
                                <span>${track.name}</span>
                            </label>
                        `).join('')}
                    </div>
                </div>
                <div class="user-modal-buttons">
                    <button type="button" class="btn btn-secondary" id="cancelUserForm">Cancelar</button>
                    <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>
    `;

    document.body.appendChild(modalOverlay);

    // Lógica para habilitar/deshabilitar el campo de tasa manual
    const autoUpdateCheckbox = modalOverlay.querySelector('#autoUpdateRate');
    const exchangeRateInput = modalOverlay.querySelector('#exchangeRate');

    autoUpdateCheckbox.addEventListener('change', (e) => {
        exchangeRateInput.disabled = e.target.checked;
        if (e.target.checked) exchangeRateInput.value = ''; // Limpiar al cambiar a automático
    });

    const closeModal = () => document.body.removeChild(modalOverlay);

    modalOverlay.querySelector('#cancelUserForm').addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
            closeModal();
        }
    });

    modalOverlay.querySelector('#userForm').addEventListener('submit', async (e) => {
        e.preventDefault();
        const form = e.target;
        const selectedTracks = Array.from(form.querySelectorAll('.allowed-track-checkbox:checked')).map(cb => parseInt(cb.value));
        
        const rateInputVal = form.querySelector('#exchangeRate').value;
        const finalRate = rateInputVal && rateInputVal.trim() !== '' ? parseFloat(rateInputVal) : null;
        
        const allyInputVal = form.querySelector('#allyName').value.trim();
        const finalAlly = allyInputVal !== '' ? allyInputVal : null;

        const payload = {
            username: form.querySelector('#username').value,
            full_name: form.querySelector('#fullName').value,
            ally_name: finalAlly,
            email: form.querySelector('#email').value,
            phone_number: form.querySelector('#phoneNumber').value,
            role: form.querySelector('#role').value,
            currency_code: form.querySelector('#currencyCode').value,
            auto_update_rate: form.querySelector('#autoUpdateRate').checked,
            allowed_track_ids: selectedTracks,
            exchange_rate: finalRate,
            enable_win_place: form.querySelector('#enableWinPlace').checked // ⭐ NUEVO: Enviamos el booleano al backend
        };
        const password = form.querySelector('#password').value;
        if (password) {
            payload.password = password;
        }

        // ⭐ LOGS DE AUDITORÍA Y DEPURACIÓN INYECTADOS ⭐
        console.log("\n========================================================");
        console.log(`📡 [DEBUG USER MODAL] Intentando ${isEditing ? 'ACTUALIZAR' : 'CREAR'} usuario...`);
        console.log("📦 Payload empaquetado para enviar a la API:");
        console.log(JSON.stringify(payload, null, 2));
        console.log("========================================================\n");

        try {
            if (isEditing) {
                await api.put(`/users/${userId}`, payload);
                Notification(notificationContainer, 'Usuario actualizado exitosamente.', 'success');
            } else {
                await api.post('/users', payload);
                Notification(notificationContainer, 'Usuario creado exitosamente.', 'success');
            }
            closeModal();
            onSave();
        } catch (error) {
            console.error("❌ [DEBUG USER MODAL] Falla en la petición a la API:", error);
            const modalNotification = document.createElement('div');
            modalOverlay.querySelector('.user-modal-content').appendChild(modalNotification);
            Notification(modalNotification, error.message || 'Error al guardar el usuario.', 'error');
        }
    });
}

export async function renderUsersManagement(container, notificationContainer) {
    const fetchUsers = async () => {
        try {
            const users = await api.get('/users');
            const usersTableBody = container.querySelector('#usersTableBody');
            if (!usersTableBody) return;
            usersTableBody.innerHTML = users.map(user => `
                <tr>
                    <td>${user.id}</td>
                    <td>${user.username}</td>
                    <td>${user.role}</td>
                    <td><span class="badge-currency">${user.currency_code === 'BOTH' ? 'USD/VES' : (user.currency_code || 'USD')}</span></td>
                    <td class="edit-rate-cell" data-id="${user.id}" style="text-align: right; font-family: monospace; font-weight: bold; font-size: 0.9rem; cursor: pointer;" title="Clic para editar usuario/tasa">
                        ${user.exchange_rate ? parseFloat(user.exchange_rate).toFixed(2) : 'N/A'}
                        ${user.auto_update_rate ? '<span class="badge-auto">AUTO</span>' : ''}
                    </td>
                    <td>${user.full_name || 'N/A'}</td>
                    <td>${user.email || 'N/A'}</td>
                    <td>${user.phone_number || 'No asignado'}</td>
                    <td>
                        <button class="btn btn-warning btn-sm edit-user-btn" data-id="${user.id}">Editar</button>
                        <button class="btn btn-danger btn-sm delete-user-btn" data-id="${user.id}">Eliminar</button>
                    </td>
                </tr>
            `).join('');

            usersTableBody.querySelectorAll('.edit-user-btn').forEach(btn => {
                btn.addEventListener('click', () => openUserModal(btn.dataset.id, notificationContainer, fetchUsers));
            });

            usersTableBody.querySelectorAll('.edit-rate-cell').forEach(cell => {
                cell.addEventListener('click', () => openUserModal(cell.dataset.id, notificationContainer, fetchUsers));
            });

            usersTableBody.querySelectorAll('.delete-user-btn').forEach(btn => {
                btn.addEventListener('click', async () => {
                    if (confirm('¿Estás seguro de que quieres eliminar este usuario? Esta acción no se puede deshacer.')) {
                        try {
                            await api.delete(`/users/${btn.dataset.id}`);
                            Notification(notificationContainer, 'Usuario eliminado exitosamente.', 'success');
                            fetchUsers();
                        } catch (error) {
                            Notification(notificationContainer, error.message || 'Error al eliminar usuario.', 'error');
                        }
                    }
                });
            });
        } catch (error) {
            Notification(notificationContainer, error.message || 'Error al cargar usuarios.', 'error');
        }
    };

    container.innerHTML = `
        <style>
            .badge-currency { 
                background: #334155; color: #cbd5e1; font-weight: bold; padding: 3px 8px; 
                border-radius: 5px; font-size: 0.75rem;
            }
            .badge-auto {
                background: #10b981; color: white; font-weight: bold; padding: 2px 5px;
                border-radius: 4px; font-size: 0.65rem; margin-left: 5px; vertical-align: middle;
                font-family: sans-serif;
            }
        </style>
        <h4>Lista de Usuarios</h4>
        <button class="btn btn-primary" id="createUserBtn">Crear Nuevo Usuario</button>
        <table class="table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Usuario</th>
                    <th>Rol</th>
                    <th>Moneda</th>
                    <th style="text-align: right;">Tasa Actual</th>
                    <th>Nombre Completo</th>
                    <th>Email</th>
                    <th>Teléfono</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody id="usersTableBody"></tbody>
        </table>
    `;

    container.querySelector('#createUserBtn').addEventListener('click', () => openUserModal(null, notificationContainer, fetchUsers));

    await fetchUsers();
}